import {Component, Input, OnInit} from '@angular/core';
import {UserModel} from '../../../../models/authentication/user.model';
import {Router} from '@angular/router';
import {StudentModel} from '../../../../models/authentication/student.model';
import {TokenModel} from '../../../../models/authentication/token.model';
import {CultureModel} from '../../../../models/localization-and-pricing/culture.model';
import {AuthService} from '../../../../services/auth.service';
import {SchoolModel} from '../../../../models/school/school.model';
import {MobileMenuService} from '../../../../mobile/mobile-menu/mobile-menu.service';
import {UserSettingsModalService} from '../../../pages/settings/user-settings-modal/user-settings-modal.service';
import {TranslateService} from '@ngx-translate/core';
import {StringExtensionModel} from '../../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-school-admin-header',
  templateUrl: './school-admin-header.component.html',
  styleUrls: ['./school-admin-header.component.css']
})
export class SchoolAdminHeaderComponent implements OnInit {

  @Input() hideHamburgerIcon = false;

  openUserDropdown = false;

  constructor(private router: Router,
              public tSv: TranslateService,
              public mobileMenuSv: MobileMenuService,
              private userSettingsSv: UserSettingsModalService,
              private authSv: AuthService) {
  }

  ngOnInit() {
  }

  userInitials(): string {

    if (UserModel.getCurrent()) {

      return UserModel.getCurrent().getTwoInitials();

    }

    return '';
  }

  userName(): string {

    if (UserModel.getCurrent()) {

      return UserModel.getCurrent().getFullName();
    }

    return '';
  }

  currentStudent(): StudentModel {

    return StudentModel.getCurrent();
  }

  currentSchool(): SchoolModel {
    return SchoolModel.getCurrent();
  }

  navigateHome() {

    this.openUserDropdown = false;
    if (StudentModel.getCurrent()) {
      this.router.navigate(['platform', 'dash']);
    } else {
      this.router.navigate(['selectstudent']);
    }

  }

  userClicked() {
    this.openUserDropdown = !this.openUserDropdown;
  }

  onMobileMenuClicked() {

    if (this.mobileMenuSv.isVisible === true) {
      this.mobileMenuSv.isVisible = false;
    } else {
      this.mobileMenuSv.isVisible = true;
    }

  }

  schoolAdminClicked() {
    this.openUserDropdown = false;
    this.router.navigate(['schooladmin', 'teachers']);
  }

  onSwitchSchoolClicked() {

    this.openUserDropdown = false;
    StudentModel.removeCurrent();
    SchoolModel.removeCurrent();
    this.router.navigate(['selectschool']);

  }

  onSwitchStudentClicked() {

    this.openUserDropdown = false;
    this.router.navigate(['selectstudent']);

  }

  onSchoolAdminClicked() {
    this.openUserDropdown = false;
    this.router.navigate(['schooladmin', 'teachers']);
  }

  onTeacherViewClicked() {
    this.router.navigate(['selectstudent']);
  }

  goToSettings() {
    this.openUserDropdown = false;
    this.userSettingsSv.onShow();
  }

  onLogoutClicked() {

    this.openUserDropdown = false;

    // Send a signout request.
    this.authSv.signOut().subscribe();
    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

    UserModel.setCurrent(null);
    StudentModel.setCurrent(null);
    SchoolModel.setCurrent(null);
    TokenModel.setCurrent(null);

  }

}
